var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.AuthLayout,
    [
      _c(_setup.AuthCardHeader, {
        attrs: { title: "Welcome, sign in to continue" },
      }),
      _vm._v(" "),
      _c(_setup.ValidationObserver, {
        attrs: { slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "form",
                  {
                    staticClass: "auth-form",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_setup.signIn)
                      },
                    },
                  },
                  [
                    _c(_setup.ValidationProvider, {
                      attrs: { rules: "required", name: "Username or email" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, failed }) {
                              return [
                                _c(_setup.CInput, {
                                  attrs: {
                                    label: "Username or Email",
                                    placeholder: "Type your username",
                                    error: failed,
                                    "error-msg": errors[0],
                                  },
                                  model: {
                                    value: _setup.username,
                                    callback: function ($$v) {
                                      _setup.username = $$v
                                    },
                                    expression: "username",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _c(_setup.ValidationProvider, {
                      attrs: { rules: "required", name: "Password" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ errors, failed }) {
                              return [
                                _c(_setup.CInput, {
                                  staticClass: "mb-2",
                                  attrs: {
                                    type: "password",
                                    label: "Password",
                                    placeholder: "Type your password",
                                    error: failed,
                                    "error-msg": errors[0],
                                  },
                                  model: {
                                    value: _setup.password,
                                    callback: function ($$v) {
                                      _setup.password = $$v
                                    },
                                    expression: "password",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "forgot-password",
                                    attrs: { href: "/forgotPassword" },
                                  },
                                  [_vm._v("Forgot your password?")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _setup.errorMessage
                      ? _c(_setup.CError, {
                          attrs: { message: _setup.errorMessage },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(_setup.CButton, {
                      attrs: {
                        type: "submit",
                        variant: "primary",
                        disabled: _setup.signingIn || !!_setup.loadingProvider,
                        text: _setup.signingIn ? "Signing in..." : "Log In",
                      },
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "signup-link" }, [
                      _vm._v("Don't have an account? "),
                      _c("a", { attrs: { href: "/signup" } }, [
                        _vm._v("Create one"),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "auth-providers" },
        [
          _c(_setup.OrDivider),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "auth-providers-buttons" },
            [
              _c(_setup.SocialAuthButton, {
                attrs: {
                  provider: "google",
                  label: "Log In with Google",
                  loading: _setup.loadingProvider === "google",
                  disabled: !!_setup.loadingProvider || _setup.signingIn,
                },
                on: {
                  click: function ($event) {
                    return _setup.signInWith("google")
                  },
                },
              }),
              _vm._v(" "),
              _c(_setup.SocialAuthButton, {
                attrs: {
                  provider: "etsy",
                  label: "Log In with Etsy",
                  loading: _setup.loadingProvider === "etsy",
                  disabled: !!_setup.loadingProvider || _setup.signingIn,
                },
                on: {
                  click: function ($event) {
                    return _setup.signInWith("etsy")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }